import { render, staticRenderFns } from "./AddProductLink.vue?vue&type=template&id=f9ca5f2a&"
import script from "./AddProductLink.vue?vue&type=script&lang=js&"
export * from "./AddProductLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports